import {RunConfigService} from '@nuskin/ns-util';
import {TdcStrings} from '@nuskin/ns-util';
import {utilModule} from '../module.js';

utilModule.service('tdcService', function() {
    let tdc = {},
        timeout = 10 * 60 * 1000;

    function _getTdc(page) {
        let _now = Date.now(),
            runConfig = RunConfigService.getRunConfig(),
            pageTdc = tdc[page];

        if (!pageTdc || runConfig.country !== pageTdc.country || runConfig.language !== pageTdc.language ||
            pageTdc.timestamp < _now - timeout) {
            if (!pageTdc) {
                pageTdc = {};
                tdc[page] = pageTdc;
            }

            pageTdc.country = runConfig.country;
            pageTdc.language = runConfig.language;
            pageTdc.timestamp = _now;
            pageTdc.tdc = TdcStrings.getStrings(page, pageTdc.language, pageTdc.country);
        }
        return pageTdc.tdc;
    }

    return {
        getTdc: function(page) {
            return _getTdc(page);
        }
    }
});
